import { _ as e } from "./extends-093996c9.js";
import c from "react";

var t = function t(_t) {
  var l = _t.blue,
      r = void 0 === l ? "#18283f" : l,
      h = _t.light,
      a = void 0 === h ? "#ffffff" : h;
  _t.dark;
  var i = _t.schema,
      s = {
    isotypebox: a,
    isotypeletter: r,
    letters: r
  };
  return "light" === (void 0 === i ? "common" : i) && (s.isotypebox = r, s.isotypeletter = a, s.letters = a), c.createElement("svg", e({
    x: "0px",
    y: "0px",
    viewBox: "0 0 485.9 86.5"
  }, _t), c.createElement("rect", {
    x: "1.3",
    y: "10.3",
    fill: s.isotypebox,
    width: "45.8",
    height: "42.8"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M483.6,53.3c-7.9,0-15.6,0-23.4,0c0.7-0.5,1.2-0.8,1.7-1.2c2.7-2,4-4.7,4-8c0-12.8,0-25.5-0.2-38.3 c-6.5,15.8-13.1,31.7-19.7,47.7c-6.7-15.3-13.4-30.5-20.2-45.9c0,0.5-0.1,0.7-0.1,0.9c0,11.7,0,23.5,0,35.2c0,4.2,1.9,7.2,5.6,9.1 c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0.1,0.1,0.1,0.2c-4.3,0-8.5,0-12.8,0c0.8-0.6,1.7-1.1,2.4-1.7c2.2-2,3.2-4.6,3.3-7.5 c0-1.8,0-3.6,0-5.3c0-9.4-0.1-18.7,0-28.1c0-4.6-1.4-8.2-5.9-10.5c0.5,0,0.8-0.1,1.1-0.1c4.8,0,9.6,0,14.5,0c0.7,0,1,0.3,1.3,0.9 c5.1,11.8,10.1,23.5,15.2,35.2c0.2,0.3,0.3,0.7,0.5,1.2c0.2-0.4,0.3-0.6,0.4-0.9c4.9-11.8,9.8-23.6,14.6-35.5c0.3-0.8,0.7-1,1.5-0.9 c4.8,0,9.6,0,14.5,0c0.3,0,0.6,0,1.2,0c-0.5,0.3-0.7,0.4-0.9,0.6c-3,1.8-4.7,4.5-4.8,8c-0.1,5.4-0.1,10.7-0.1,16.1 c0,6.6,0,13.3,0.1,19.9c0.1,3.7,1.9,6.5,5.1,8.4C483.1,53,483.2,53.1,483.6,53.3z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M392.1,28.5c-0.1,0.1-0.1,0.2-0.1,0.2c0,5.3-0.1,10.7,0.1,16c0.1,3.6,1.9,6.4,5.1,8.2c0.1,0.1,0.2,0.2,0.5,0.3 c-7.8,0-15.5,0-23.4,0c0.6-0.4,1-0.6,1.5-0.9c3-2.1,4.3-5,4.3-8.6c0-11.4,0-22.8,0-34.2c0-4.1-1.6-7.2-5.3-9.2 c-0.1-0.1-0.2-0.1-0.5-0.4c0.5,0,0.8,0,1,0c8.4,0,16.9,0,25.3,0c4.4,0,8.4,1.2,11.9,4c6.7,5.5,6.7,18.8-3.8,23 c-4,1.6-8.3,1.8-12.5,1.7C394.8,28.7,393.5,28.6,392.1,28.5z M391.9,1.1c0,0.4,0,0.8,0,1.2c0,7.4,0,14.8,0,22.3c0,2.9,0,2.9,2.9,2.9 c4.7,0.1,8.1-2.4,9.1-7c0.5-2.2,0.7-4.5,0.5-6.8c-0.2-4.3-2-8-5.6-10.6C396.9,1.7,394.6,1,391.9,1.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M0,7.8v46.1h48.2V7.8H0z M23.7,45.5H5.9V16.2h4.6v25.2h13.2V45.5z M42.3,20.3h-8.7v25.2H29V20.3h-8.7v-4.1h22.1 V20.3z"
  }), c.createElement("polygon", {
    fill: s.letters,
    points: "118.5,15.7 130.9,15.7 130.9,51.8 137.5,51.8 137.5,15.7 150,15.7 150,9.9 118.5,9.9 "
  }), c.createElement("path", {
    fill: s.letters,
    d: "M214.3,25.9c0-9.7-6.3-16-17.9-16h-10.7v41.9h6.6v-10h4.1c1.1,0,2.1-0.1,3-0.2l7.2,10.2h7.8l-8.5-11.9 C211.4,37.4,214.3,32.4,214.3,25.9z M196.1,36.1h-3.9V15.7h3.9c8,0,11.3,3.8,11.3,10.2C207.5,32.3,204.2,36.1,196.1,36.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M238.4,46.4c-8.4,0-14.6-6.5-14.6-15.5c0-8.9,6-15.5,14.4-15.5c5.5,0,9.1,2,11.9,5.7l5.1-3.6 c-3.6-5.1-9-8.1-16.8-8.1c-12,0-21.4,9.1-21.4,21.5c0,12.4,9.2,21.5,21.2,21.5c8.1,0,13.6-2.8,17.9-8.6l-5.1-3.5 C247.8,44.3,243.8,46.4,238.4,46.4z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M319.5,25.9c0-9.7-6.4-16-17.9-16h-10.7v41.9h6.6v-10h4.1c1,0,2.1-0.1,3-0.2l7.2,10.2h7.8l-8.5-11.9 C316.6,37.4,319.5,32.4,319.5,25.9z M301.4,36.1h-3.9V15.7h3.9c8,0,11.3,3.8,11.3,10.2C312.7,32.3,309.5,36.1,301.4,36.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M339.7,9h-0.4L321,51.8h6.7l2.4-5.9h18.7l2.4,5.9h7L339.7,9z M332.5,40.1l7-16.6l6.8,16.6H332.5z"
  }), c.createElement("polygon", {
    fill: s.letters,
    points: "259.7,51.8 287,51.8 287,45.9 266.3,45.9 266.3,38.8 284.1,38.8 284.1,33.1 266.3,33.1 266.3,15.7 287,15.7 287,9.9 259.7,9.9 "
  }), c.createElement("polygon", {
    fill: s.letters,
    points: "160.7,38.9 178.5,38.9 178.5,33.1 160.7,33.1 160.7,15.7 181.6,15.7 181.6,9.9 154.1,9.9 154.1,51.8 181.7,51.8 181.7,45.9 160.7,45.9 "
  }), c.createElement("path", {
    fill: s.letters,
    d: "M99.9,9L84.1,46H67.4v-36h-6.6v41.9h27.5l2.4-5.9h18.8l2.4,5.9h7L100.3,9H99.9z M93.1,40.1l7-16.6l6.8,16.6 H93.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M428.9,81.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2 C435.1,78.4,432.3,81.2,428.9,81.2z M428.9,71.1c-2.1,0-3.9,1.7-3.9,3.9c0,2.1,1.7,3.9,3.9,3.9c2.1,0,3.9-1.7,3.9-3.9 C432.8,72.8,431,71.1,428.9,71.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M428.9,66.4c-0.6,0-1.2-0.5-1.2-1.2v-0.7c0-0.6,0.5-1.2,1.2-1.2c0.6,0,1.2,0.5,1.2,1.2v0.7 C430.1,65.9,429.5,66.4,428.9,66.4z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M428.9,86.5c-0.6,0-1.2-0.5-1.2-1.2v-0.7c0-0.6,0.5-1.2,1.2-1.2c0.6,0,1.2,0.5,1.2,1.2v0.7 C430.1,85.9,429.5,86.5,428.9,86.5z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M439.3,76.1h-0.7c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2h0.7c0.6,0,1.2,0.5,1.2,1.2 C440.4,75.6,439.9,76.1,439.3,76.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M419.2,76.1h-0.7c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2h0.7c0.6,0,1.2,0.5,1.2,1.2 C420.4,75.6,419.9,76.1,419.2,76.1z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M435.7,69.3c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.5-0.5-1.2,0-1.6l0.5-0.5c0.5-0.5,1.2-0.5,1.6,0 c0.5,0.5,0.5,1.2,0,1.6l-0.5,0.5C436.3,69.2,436,69.3,435.7,69.3z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M421.6,83.4c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.5-0.5-1.2,0-1.6l0.5-0.5c0.5-0.5,1.2-0.5,1.6,0 c0.5,0.5,0.5,1.2,0,1.6l-0.5,0.5C422.2,83.3,421.9,83.4,421.6,83.4z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M436.2,83.4c-0.3,0-0.6-0.1-0.8-0.3l-0.5-0.5c-0.5-0.5-0.5-1.2,0-1.6c0.5-0.5,1.2-0.5,1.6,0l0.5,0.5 c0.5,0.5,0.5,1.2,0,1.6C436.8,83.3,436.5,83.4,436.2,83.4z"
  }), c.createElement("path", {
    fill: s.letters,
    d: "M422.1,69.3c-0.3,0-0.6-0.1-0.8-0.3l-0.5-0.5c-0.5-0.5-0.5-1.2,0-1.6c0.5-0.5,1.2-0.5,1.6,0l0.5,0.5 c0.5,0.5,0.5,1.2,0,1.6C422.7,69.2,422.4,69.3,422.1,69.3z"
  }), c.createElement("circle", {
    opacity: "0.5",
    fill: s.letters,
    cx: "374.6",
    cy: "74.9",
    r: "2.7"
  }), c.createElement("circle", {
    opacity: "0.5",
    fill: s.letters,
    cx: "483.2",
    cy: "74.9",
    r: "2.7"
  }));
};

export { t as LaTerceraPM };